<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de tipos de peligros</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Nombre">
                    <b-form-input v-model="filterTypesOfDangersSga.name" type="text" placeholder="Buscar por nombre"
                        class="form-control" />
                </b-form-group>
            </b-col>
            
            <b-col md="3">
                <b-form-group label="Estado">
                    <el-select v-model="filterTypesOfDangersSga.is_active" clearable filterable size="medium"
                        placeholder="Buscar por estado">
                        <el-option v-for="item in statesSga" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchTypeOfDangerSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <el-tooltip effect="light" placement="top" popper-class="py-1 px-2" content="Sincronizar idiomas">
                        <b-button variant="warning" class="ml-1" @click="asyncLanguagesTypeOfDangerSga">
                            <i class="fa fa-language" aria-hidden="true"></i>
                        </b-button>
                    </el-tooltip>
                    <b-button v-if="canManageConfiguration" variant="primary" @click="createTypeOfDanger" class="ml-1">
                        <i class="fa fa-plus"></i>
                        <span class="ml-1" v-text="'Nuevo tipo de peligro'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal_create_typeOfDanger" size="md" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nuevo' }} tipo de peligro
                </template>
                <formTypesOfDangers />
            </b-modal>

            <b-col md="12">
                <b-form-group>
                    <b-table :items="typesOfDangers.data" :fields="fields" responsive striped hover bordered
                        thead-tr-class="table-active" show-empty thead-class="table-active"
                        empty-text="No hay resultados para mostrar.">
                        <template #cell(name)="data">
                            <div v-bind:style="{
                                'background-color': data.item.color,
                                'color': 'white',
                                'border-radius': '8px',
                                'padding': '5px'
                            }">
                                {{ data.item.name }}
                            </div>
                        </template>
                        <template #cell(edition)="data">
                            <b-badge variant="info" class="text-white" v-text="data.item.version.version" />
                        </template>
                        <template #cell(is_active)="data">
                            <b-badge :variant="data.item.is_active ? 'success' : 'danger'"
                                v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
                        </template>
                        <template #cell(actions)="data">
                            <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                                <el-tooltip content="Editar" placement="top" effect="light">
                                    <el-button type="text" class="text-primary" @click="editTypesOfDanger(data.item)">
                                        <i class="fa fa-edit fa-lg"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                    placement="top" effect="light">
                                    <el-button type="text" @click="changeStatus(data.item.id)"
                                        :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                        <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterTypesOfDangersSga.page"
                            :total="filterTypesOfDangersSga.total" :current-page="filterTypesOfDangersSga.page"
                            :page-size="filterTypesOfDangersSga.per_page" @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import formTypesOfDangers from './FormTypesOfDangers.vue';
export default {
    name: 'TypesOfDangers',
    components: {
        formTypesOfDangers,
    },
    data() {
        return {
        };
    },

    computed: {
        ...mapState('sgaTypesOfDangers', ['typesOfDangers', 'action', 'statesSga', 'filterTypesOfDangersSga']),
        ...mapState('sgaVersions', ['statesSga', 'activeGlobalVersion', 'activeVersions']),
        
        canManageConfiguration() {
            const activeVersion = this.activeVersions && this.activeVersions.find(v => v.id === this.activeGlobalVersion);
            
            const isVersionLocked = (activeVersion && activeVersion.is_locked) || false;
            
            return !isVersionLocked;
        },
        fields() {
            const baseFields = [
                {
                    key: "edition",
                    label: "Edición",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "code",
                    label: "Codigo",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "name",
                    label: "Nombre",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "priority",
                    label: "Prioridad",
                    tdClass: "text-center",
                    thClass: "text-center",
                },                
                {
                    key: "is_active",
                    label: "Estado",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "user.name",
                    label: "Creado por",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ];

            if (this.canManageConfiguration) {
                baseFields.push({
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center",
                });
            }

            return baseFields;
        }
    },

    watch: {

        'activeGlobalVersion'(next, prev) {
            if (next != prev && next) {
                this.setEditionToFilterTypesOfDangersSga(next)
                this.searchTypeOfDangerSga();
            }
        }

    },

    methods: {
        ...mapActions('sgaTypesOfDangers', ['getTypeOfDangersSga', 'changeStatusTypeOfDangerSga', 'showTypeOfDangerSga', 'asyncLanguagesTypeOfDangerSga']),
        ...mapMutations('sgaTypesOfDangers', ['setActionTypeOfDanger', 'setDefaultFilterSgaTypesOfDangers', 'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination', 'setTypeOfDangerSga', 'setEditionToFilterTypesOfDangersSga']),

        createTypeOfDanger() {
            this.setActionTypeOfDanger('create');
            this.$bvModal.show('modal_create_typeOfDanger');
        },

        async clearFilter() {
            this.setDefaultFilterSgaTypesOfDangers();
            this.setEditionToFilterTypesOfDangersSga(this.activeGlobalVersion)
            await this.getTypeOfDangersSga();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getTypeOfDangersSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getTypeOfDangersSga();
        },

        async changeStatus(id) {
            await this.changeStatusTypeOfDangerSga(id);
            await this.getTypeOfDangersSga();
        },

        editTypesOfDanger(typeOfDanger) {
            this.showTypeOfDangerSga(typeOfDanger.id);
            this.setActionTypeOfDanger('edit');
            this.$bvModal.show('modal_create_typeOfDanger');
        },

        async searchTypeOfDangerSga() {
            await this.getTypeOfDangersSga(true);
        },
    },
};
</script>
